import { render, staticRenderFns } from "./lite-visited.vue?vue&type=template&id=20f71dbe&"
import script from "./lite-visited.vue?vue&type=script&lang=js&"
export * from "./lite-visited.vue?vue&type=script&lang=js&"
import style0 from "./lite-visited.vue?vue&type=style&index=0&id=20f71dbe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports